// IT translations
export const it = {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Servizi',
      about: 'Chi Siamo',
      successStories: 'Storie di Successo',
      blog: 'Blog',
      contact: 'Contatti'
    },
    // Hero Section
    hero: {
      badge: 'Genealogista Esperta Laura Stella - 30 Anni di Esperienza',
      title: 'Scopri le Tue',
      titleHighlight: 'Radici Italiane',
      description: 'Ricerca genealogica professionale che ti connette alle tue origini italiane',
      introHeadline: 'Ogni storia familiare inizia da una domanda. Noi ti aiutiamo a trovare le risposte.',
      introSupport: 'Ricerca basata su fonti storiche reali, documenti verificabili e supporto umano dedicato.',
      cta: 'Inizia il Tuo Viaggio',
      viewServices: 'Vedi Servizi',
      stats: {
        projects: 'Progetti Completati',
        experience: 'Anni di Esperienza',
        countries: 'Paesi Serviti'
      },
      certified: 'Esperto Certificato',
      certifiedSub: 'Ricerca Archivi Italiani'
    },
    // Services Section
    services: {
      title: 'I Nostri Servizi',
      subtitle: 'Soluzioni complete per la ricerca genealogica',
      items: [
        {
          title: 'Ricerca Genealogica',
          description: 'Ricerca approfondita degli archivi italiani per tracciare la storia della tua famiglia attraverso generazioni.'
        },
        {
          title: 'Recupero Documenti',
          description: 'Otteniamo certificati di nascita, matrimonio e morte dagli archivi comunali e parrocchiali italiani.'
        },
        {
          title: 'Assistenza Cittadinanza',
          description: 'Guida esperta attraverso il processo di richiesta della cittadinanza italiana per discendenza (jure sanguinis).'
        },
        {
          title: 'Traduzione Documenti',
          description: 'Traduzione professionale e apostille di documenti italiani per uso legale.'
        },
        {
          title: 'Tour Ancestrali',
          description: 'Viaggi personalizzati nei luoghi di origine della tua famiglia in Italia.'
        }
      ]
    },
    // About Section
    about: {
      title: 'Chi Siamo',
      subtitle: 'La Tua Partner nella Scoperta del Patrimonio Italiano',
      description1: 'Con oltre 30 anni di esperienza nella ricerca genealogica italiana, Laura Stella ha aiutato centinaia di famiglie a scoprire le loro radici italiane e ottenere la cittadinanza italiana.',
      description2: 'Il nostro team di ricercatori esperti lavora direttamente con gli archivi italiani, le parrocchie e gli uffici comunali per trovare i documenti necessari per la tua ricerca familiare.',
      features: [
        'Accesso diretto agli archivi italiani',
        'Team di ricercatori madrelingua',
        'Oltre 500 casi di successo',
        'Supporto completo per la cittadinanza'
      ]
    },
    // Success Stories
    stories: {
      title: 'Storie di Successo',
      subtitle: 'Famiglie che hanno scoperto le loro radici',
      items: [
        {
          name: 'Marco R.',
          location: 'New York, USA',
          quote: 'La precisione e l\'accuratezza della ricerca mi hanno stupito. Hanno trovato dettagli sulla mia famiglia che nemmeno i miei nonni conoscevano!'
        },
        {
          name: 'Sarah M.',
          location: 'Sydney, Australia',
          quote: 'Hanno trovato documenti della mia famiglia risalenti al 1800. Un\'esperienza incredibile.'
        },
        {
          name: 'Carlos G.',
          location: 'Buenos Aires, Argentina',
          quote: 'Professionalità e dedizione. Hanno risolto un caso complesso che altri avevano abbandonato.'
        }
      ]
    },
    // Blog
    blog: {
      title: 'Blog Genealogia',
      subtitle: 'Guide, consigli e storie sulla ricerca genealogica italiana',
      readMore: 'Leggi Articolo',
      backToSite: 'Torna al Sito',
      backToBlog: 'Torna al Blog',
      minRead: 'min di lettura',
      categories: {
        citizenship: 'Cittadinanza',
        research: 'Ricerca',
        genealogy: 'Genealogia',
        documents: 'Documenti'
      }
    },
    // Contact
    contact: {
      title: 'Contattaci',
      subtitle: 'Inizia il tuo viaggio verso le radici italiane',
      form: {
        name: 'Nome Completo',
        email: 'Email',
        phone: 'Telefono',
        message: 'Messaggio',
        ancestorOrigin: 'Luogo di origine del tuo antenato (se conosciuto)',
        submit: 'Invia Richiesta'
      },
      info: {
        title: 'Informazioni di Contatto',
        email: 'italianrootsdiscovery@gmail.com',
        phone: '+39 3318792031',
        address: 'Milano • Torino • Genova • Venezia • Padova • Roma • Napoli • Palermo'
      }
    },
    // Footer
    footer: {
      description: 'Ricerca genealogica professionale che ti connette alle tue radici italiane.',
      quickLinks: 'Link Rapidi',
      contactUs: 'Contattaci',
      followUs: 'Seguici',
      rights: 'Tutti i diritti riservati.',
      terms: 'Termini e Condizioni',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy'
    }
  };
